import React, {useState, useRef, useEffect} from "react";
import {FiMoreVertical, FiCheck} from "react-icons/fi";

import "./DropdownMenu.scss";

const MenuItem = ({item, onClose, isSubmenuItem}) => {
    const [showSubMenu, setShowSubMenu] = useState(false);

    if (Array.isArray(item.items)) {
        return (
            <li className="dropdown-item has-submenu">
                <span
                    onClick={() => setShowSubMenu(!showSubMenu)}
                    className="dropdown-item-label"
                >
                    {item.label}
                </span>
                {showSubMenu && (
                    <ul className="dropdown-submenu">
                        {item.items.map((subItem, i) => (
                            <MenuItem
                                key={i}
                                item={subItem}
                                onClose={onClose}
                                isSubmenuItem={true}
                            />
                        ))}
                    </ul>
                )}
            </li>
        );
    }

    return (
        <li
            className={`dropdown-item${item.disabled ? ' disabled' : ''}`}
            onClick={(e) => {
                if (item.disabled) {
                    e.preventDefault();
                    return;
                }
                e.stopPropagation();
                item.onClick?.();
                // Zavřít menu pouze pokud není položka v submenu a má onClick handler
                if (!isSubmenuItem && item.onClick) {
                    onClose();
                }
            }}
        >
            <span className="dropdown-item-label">
                {item.checked !== undefined && (
                    <span className="checkbox">
                        {item.checked && <FiCheck/>}
                    </span>
                )}
                {item.label}
            </span>
        </li>
    );
};

export default function DropdownMenu({items = []}) {
    const [open, setOpen] = useState(false);
    const menuRef = useRef(null);

    const toggleMenu = () => setOpen((prev) => !prev);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div className="DropdownMenu" ref={menuRef}>
            <button className="dropdown-trigger" onClick={toggleMenu}>
                <FiMoreVertical size={20}/>
            </button>
            {open && (
                <ul className="dropdown-list">
                    {items.map((item, i) => (
                        <MenuItem
                            key={i}
                            item={item}
                            onClose={() => setOpen(false)}
                            isSubmenuItem={false}
                        />
                    ))}
                </ul>
            )}
        </div>
    );
}